import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const seoRuntime = createHostModule({
    links: ({ channel }) => function links(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'links',
            args,
        });
    },
    metaTags: ({ channel }) => function metaTags(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'metaTags',
            args,
        });
    },
    structuredData: ({ channel }) => function structuredData(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'structuredData',
            args,
        });
    },
    title: ({ channel }) => function title(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'title',
            args,
        });
    },
    setLinks: ({ channel }) => function setLinks(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'setLinks',
            args,
        });
    },
    setMetaTags: ({ channel }) => function setMetaTags(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'setMetaTags',
            args,
        });
    },
    setStructuredData: ({ channel }) => function setStructuredData(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'setStructuredData',
            args,
        });
    },
    setTitle: ({ channel }) => function setTitle(...args) {
        return channel.invoke({
            namespace: 'seo',
            method: 'setTitle',
            args,
        });
    },
});
//# sourceMappingURL=seo.runtime.js.map